import React, {useState, useEffect } from 'react';
import './App.css';
import Todo from './components/Todo';
import { db,  firebase, firebaseui, auth} from './utils/firebase.js';
import { collection , query, orderBy , where, onSnapshot, addDoc, deleteDoc, serverTimestamp, doc} from 'firebase/firestore';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Item from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import IconButton from '@mui/material/IconButton';
import Tab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Typography from '@mui/material/Typography';
import Col from './components/Col';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toolbar from '@mui/material/Toolbar';
import Chip from '@mui/material/Chip';
import itLocale from "date-fns/locale/it";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import InputAdornment from '@mui/material/InputAdornment';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import { List , ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { getAuth, signInWithEmailAndPassword , signInWithCredential, signOut, onAuthStateChanged} from "firebase/auth";
import KeyIcon from '@mui/icons-material/Key';
import KeyOffIcon from '@mui/icons-material/KeyOff';
import EmailIcon from '@mui/icons-material/Email';
import PasswordIcon from '@mui/icons-material/Password';
import EventIcon from '@mui/icons-material/Event';
import { alpha, styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'green',
    borderBottom: '0px',
    backgroundColor: 'red'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
    borderBottom: '0px'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'red',
    },
    '&:hover fieldset': {
      borderColor: 'yellow',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'red',
      borderBottom: '0px'
    },
  },
});



function App() {


  
  const [open, setOpen] = React.useState(false);
  const [openRemove, setOpenRemove] = React.useState(false);
  const [openLogin, setOpenLogin] = React.useState(false);
  const [user, setUser] = useState();
  const auth = getAuth();

  const handleClickOpenLogin = () => {
    setOpenLogin(true);
  };
  const handleCloseLogin = () => {
    setOpenLogin(false);
  };


  const login = () => {
    let email = document.getElementById('input_email').value;
    let password = document.getElementById('input_password').value;

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        // console.log("sign in : "+user);
        setUser(user)
        // ...
      })
      .catch((error) => {
        setUser('')
        // const errorCode = error.code;
        // const errorMessage = error.message;
    });

    setOpenLogin(false);
  }

  const logout = () => {
    signOut(auth);
    setUser('');
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenRemove = () => {
    setOpenRemove(true);
  };
  const handleCloseRemove = () => {
    setOpenRemove(false);
  };

  const getValue = (event) => {
    setValue(event.target.value);
  };

  const addValue = () => {

    let name = document.getElementById('input_name').value;


    let selected = document.getElementsByClassName('selected');

    for(let i = 0; i < selected.length; i++){
      let date = new Date(selected[i].dataset.day);
      let campo = selected[i].dataset.campo;

      if(name != ''){
        const docRef = addDoc(collection(db, "prenotazione"), {
          name: name,
          campo: campo,
          start_datetime: date
        });
      }

      
      // selected[i].classList.remove('selected');

      // selected[i].parentNode.remove();


    }

    
    let fab = document.getElementsByClassName('fab-prenota');
    
    fab[0].classList.remove('shown');
    
    // window.location.reload(false)
    
    setOpen(false);
    
    let _selected = document.getElementsByClassName('selected');
    for(let i = 0; i < _selected.length; i++){
      _selected[i].classList.toggle('selected');
    }
     _selected = document.getElementsByClassName('selected');
    for(let i = 0; i < _selected.length; i++){
      _selected[i].classList.toggle('selected');
    }

  };

  const removeValue = () => {

    let selected = document.getElementsByClassName('selectedToRemove');
    console.log(selected);

    for(let i = 0; i < selected.length; i++){
      let prenotazioneId = selected[i].dataset.prenotazione;

      // const docRef = deleteDoc(db, "prenotazione", prenotazioneId);
      deleteDoc(doc(db, "prenotazione", prenotazioneId))
      // deleteDoc(collection(db, "prenotazione", prenotazioneId))
      // selected[i].classList.remove('selected');

      // selected[i].parentNode.remove();


    }

    
    let fab = document.getElementsByClassName('fab-prenota-remove');
    
    fab[0].classList.remove('shown');
    
    // window.location.reload(false)
    
    setOpenRemove(false);
    
    let _selected = document.getElementsByClassName('selectedToRemove');
    for(let i = 0; i < _selected.length; i++){
      _selected[i].classList.toggle('selected');
    }
     _selected = document.getElementsByClassName('selectedToRemove');
    for(let i = 0; i < _selected.length; i++){
      _selected[i].classList.toggle('selectedToRemove');
    }

  };

  const [valueTab, setValueTab] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };


  const [todos,setTodos]=useState([]);
  const [input, setInput]=useState('');
  const [value, setValue] = React.useState(new Date());

  useEffect(() => {

    // const loggedInUser = localStorage.getItem("user");
    // if (loggedInUser) {
    //   setUser(loggedInUser);
    // }

    getAuth().onAuthStateChanged((user) => {
      setUser(user);
    });

    onSnapshot(q,(snapshot)=>{
      
      setTodos(snapshot.docs.map(doc=>({
      id: doc.id,
      item: doc.data()
      })))
    })
  

  },[value]);

  // const addTodo=(e)=>{
  //   e.preventDefault();
  //   addDoc(collection(db,'campo'),{
  //   todo:input,
  //   timestamp: serverTimestamp()
  //   })
  //   setInput('')
  // };
  // const q=query(collection(db,'campo'),orderBy('name','desc'), where("sport", "==", "padel"));
  // var [startDate, setStartDate] = React.useState(new Date());
  // var [endDate, setEndDate] = React.useState(new Date());

  const startDate = new Date(value);
  startDate.setHours(8, 0, 0);
  // // console.log(startDate);

  const endDate = new Date(value);
  endDate.setHours(23, 59, 0);
  // console.log(endDate);

  // const q=query(collection(db,'prenotazione'), where("start_datetime", ">=", new Date(startDate)), where("start_datetime", "<=", new Date(endDate)));
  const hours = [];
  // const temp = new Date();

  const q = query(collection(db,'prenotazione'), orderBy("start_datetime"),where("start_datetime", ">=", new Date(startDate)), where("start_datetime", "<=", new Date(endDate)));
  // const q = query(collection(db,'prenotazione'), where("start_datetime", ">=", new Date(startDate)));
  

  // console.log(value);
  // console.log(startDate)
  // console.log(endDate)
  // console.log(q);
  

  // for (let i = 8; i <= 23; i++) {

  //   var itemHour = {};
  //   itemHour['hour'] = i;
  //   itemHour['prenotazioni'] = [];
    

  //   hours[i] = itemHour;
  // }
  
  // for(let i = 0; i < todos.length; i++){
  //   let _date = new Date(todos[i]['item']['start_datetime'].toDate());
  //   let _hour = _date.getHours();


  //   hours[_hour]['prenotazioni'].push(todos[i]);
  // }
  // console.log(hours)

  // console.log(todos)
  // console.log(q)
  // console.log(value)
  // startDate.setHours(8, 0)
  // console.log(startDate)
  // console.log(endDate)
  
  
  let campi = [];

  campi['padel1'] = {key: 'padel1', sport: 'padel', prenotazione: [], label: 'PADEL',  number: 1, size: 2, day: new Date(startDate)};
  campi['padel2'] = {key: 'padel2', sport: 'padel', prenotazione: [], label: 'PADEL', number: 2, size: 2, day: new Date(startDate)};
  campi['padel3'] = {key: 'padel3', sport: 'padel', prenotazione: [], label: 'PADEL', number: 3, size: 2, day: new Date(startDate)};
  campi['calcetto1'] = {key: 'calcetto1', sport: 'calcetto', prenotazione: [], label: 'CALCETTO', number: 4,  size: 1, day: new Date(startDate)};



  for(let i = 0; i < todos.length; i++){
    let _date = new Date(todos[i]['item']['start_datetime'].toDate());
    let _hour = _date.getHours();
    let campo = todos[i]['item']['campo'];
  
    campi[campo].prenotazione.push(todos[i]);
  }


  let _campi = [];

  Object.values(campi).forEach((element) => {
    _campi.push(element);
  });


  // let loginBox = <Button variant="outlined" endIcon={<KeyIcon />} size="small" onClick={handleClickOpenLogin}>Login</Button>;
  let loginBox = <Chip className="chip-login" size="small"  label="login"  onClick={handleClickOpenLogin} icon={<KeyIcon />} />;

  if(user){
    loginBox = <Box>
      <Chip
        size="small"
        color="warning"
        label={user.email}
        onClick={logout}
        onDelete={logout}
        deleteIcon={<KeyOffIcon />}
        // variant="outlined"
      />
   </Box>;
  }
  return (
    <div className="App">
      <div class="bg-image"></div>
      <Container className="Container" maxWidth="sm">
        

        <Toolbar sx={{ justifyContent: "space-between" }} disableGutters={true}>
          {/* <Typography  variant="h4" component="h2">
            Salento Padel
          </Typography> */}
          <Box className="logo"></Box>
          
          <Stack  spacing={1} 
            direction="column"
            justifyContent="center"
            alignItems="flext-start"
            className="top-center-stack"
          >
            {/* <Box>
          <FacebookIcon />
          <InstagramIcon />

          </Box> */}
            {/* <Chip
            // variant="outlined"
              color="primary"
              label='+39 377 3861132'
              onClick={() =>{window.location.href = 'tel:+39 377 3861132'}}
              // onDelete={logout}
              icon={<LocalPhoneRoundedIcon />}
              size="small"
              className="phone-chip"
              // variant="outlined"
            /> */}
            {/* <Chip
            // variant="outlined"
              color="secondary"
              label='Via Matine, 139 73031 Alessano'
              // onClick={() =>{window.location.href = 'tel:+39 377 3861132'}}
              // onDelete={logout}
              icon={<LocationOnIcon />}
              size="small"
              // variant="outlined"
            /> */}
          </Stack>
          
          <Stack  spacing={2} 
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
            className="top-right-stack"
          >
          {loginBox}
          <Chip
          // variant="outlined"
            color="primary"
            label='+39 377 3861132'
            onClick={() =>{window.location.href = 'tel:+39 377 3861132'}}
            // onDelete={logout}
            icon={<LocalPhoneRoundedIcon />}
            // variant="outlined"
          />
          </Stack>
        </Toolbar>

          {/* <Grid item xs={12} sm={6} className="Calendar">
            <Item>
              <h2>Prenota campi</h2>
              </Item>
            <Item>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                openTo="month" 
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                 
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider> */}
            {/* </Item>
          </Grid>  */}
            <Stack spacing={2}>
              
            {/* <Item>
              <h2>Prenota campi</h2>
              {loginBox}
              </Item> */}
                <Grid container className="todo__list center" spacing={0}>
                  <Grid item xs={2} sm={2}>
                    <Stack spacing={0} className="center">

                    <Box className="header-cell-sticky-wrapper">
                      <div className='header-cell date-wrapper center'>
                        {/* <AccessTimeIcon  color="primary"/> */}
                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
            {/* <DesktopDatePicker
              label="Date desktop"
              inputFormat="MM/dd/yyyy"
              value={value}
                          onChange={(newValue) => {
                            setValue(newValue);
                          
                          }}
              renderInput={(params) => <TextField {...params} />}
            /> */}
            <MobileDatePicker
                locale={itLocale}
                // label="Data"
                closeOnSelect="true"
                inputFormat="d MMM"
                value={value}
                className="date-picker-box"
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                onClose={() => {document.getElementById('dateInput').blur();document.getElementById('dateInput').blur()}}
                renderInput={(params) => <CssTextField 
                  id="dateInput"
                  fullWidth
                  className="date-picker-box"
                  variant="standard"
                    size="small" {...params} />}
              />
              </LocalizationProvider>
                      </div>
                        </Box>
                      <div className="cell center"><div className="hour-cell center">8:00 - 8:30</div></div>
                      <div className="cell center"><div className="hour-cell center">8:30 - 9:00</div></div>
                      <div className="cell center"><div className="hour-cell center">9:00 - 9:30</div></div>
                      <div className="cell center"><div className="hour-cell center">9:30 - 10:00</div></div>
                      <div className="cell center"><div className="hour-cell center">10:00 - 10.30</div></div>
                      <div className="cell center"><div className="hour-cell center">10:30 - 11:00</div></div>
                      <div className="cell center"><div className="hour-cell center">11:00 - 11:30</div></div>
                      <div className="cell center"><div className="hour-cell center">11:30 - 12:00</div></div>
                      <div className="cell center"><div className="hour-cell center">12:00 - 12:30</div></div>
                      <div className="cell center"><div className="hour-cell center">12:30 - 13:00</div></div>
                      <div className="cell center"><div className="hour-cell center">13:00 - 13:30</div></div>
                      <div className="cell center"><div className="hour-cell center">13:30 - 14:00</div></div>
                      <div className="cell center"><div className="hour-cell center">14:00 - 14:30</div></div>
                      <div className="cell center"><div className="hour-cell center">14:30 - 15:00</div></div>
                      <div className="cell center"><div className="hour-cell center">15:00 - 15:30</div></div>
                      <div className="cell center"><div className="hour-cell center">15:30 - 16:00</div></div>
                      <div className="cell center"><div className="hour-cell center">16:00 - 16:30</div></div>
                      <div className="cell center"><div className="hour-cell center">16:30 - 17:00</div></div>
                      <div className="cell center"><div className="hour-cell center">17:00 - 17:30</div></div>
                      <div className="cell center"><div className="hour-cell center">17:30 - 18:00</div></div>
                      <div className="cell center"><div className="hour-cell center">18:00 - 18:30</div></div>
                      <div className="cell center"><div className="hour-cell center">18:30 - 19:00</div></div>
                      <div className="cell center"><div className="hour-cell center">19:00 - 19:30</div></div>
                      <div className="cell center"><div className="hour-cell center">19:30 - 20:00</div></div>
                      <div className="cell center"><div className="hour-cell center">20:00 - 20:30</div></div>
                      <div className="cell center"><div className="hour-cell center">20:30 - 21:00</div></div>
                      <div className="cell center"><div className="hour-cell center">21:00 - 21:30</div></div>
                      <div className="cell center"><div className="hour-cell center">21:30 - 22:00</div></div>
                      <div className="cell center"><div className="hour-cell center">22:00 - 22:30</div></div>
                      <div className="cell center"><div className="hour-cell center">22:30 - 23:00</div></div>
                      <div className="cell center"><div className="hour-cell center">23:00 - 23:30</div></div>
                      <div className="cell center"><div className="hour-cell center">23:30 - 24:00</div></div>


                    </Stack>

                  </Grid>
                  <Grid container item xs={10} sm={10}>
                  {/* <Col></Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col> */}
                  {_campi.map(item=> <Col key={item.id} arr={item} user={user} />)}
                  </Grid> 

                  {/* <ul className='ul-hours'> */}
                  {/* <Grid item xs={12} sm={6} className="todo__list"> */}
                {/* {todos.map(item=> <Todo key={item.id} arr={item} />)} */}
                {/* {hours.map(item=> <Todo key={item.hour} arr={item}/>)} */}
                </Grid>
                {/* </ul> */}
            </Stack>
            <div className="fab-prenota">
              <Fab color="primary" aria-label="add" onClick={handleClickOpen}>
                <AddIcon />
              </Fab>
            </div>
            <div className="fab-prenota-remove">
              <Fab color="error" aria-label="add" onClick={handleClickOpenRemove}>
                <DeleteForeverIcon />
              </Fab>
            </div>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle className="center"><Chip className="chip-loegin" size="small" label="PRENOTAZIONE" color="primary"  icon={<EventIcon />} /></DialogTitle>
              <DialogContent>
                {/* <DialogContentText>
                  To subscribe to this website, please enter your email address here. We
                  will send updates occasionally.
                </DialogContentText> */}
                <TextField
                  autoFocus
                  margin="dense"
                  id="input_name"
                  label="Nominativo"
                  type="text"
                  fullWidth
                  variant="outlined"
                  // size="small"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Annulla</Button>
                <Button variant="contained" onClick={addValue}>Conferma</Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openRemove}
              onClose={handleCloseRemove}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title" className="center">
                {"Sei sicuro?"}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseRemove}>Annulla</Button>
                <Button variant="contained" color="error" onClick={removeValue} autoFocus>
                  Elimina
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={openLogin} onClose={handleCloseLogin}>
              <DialogTitle className="center"><Chip className="chip-login"   label="login"   icon={<KeyIcon />} /></DialogTitle>
              <DialogContent>
                {/* <DialogContentText>
                  To subscribe to this website, please enter your email address here. We
                  will send updates occasionally.
                </DialogContentText> */}
                <TextField
                  autoFocus
                  margin="dense"
                  id="input_email"
                  label="Email"
                  type="email"
                  fullWidth
                  variant="outlined"
                  // size="small"
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <EmailIcon />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
                <TextField
                  margin="dense"
                  id="input_password"
                  label="Password"
                  type="password"
                  fullWidth
                  variant="outlined"
                  // size="small"

                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <PasswordIcon />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              </DialogContent>
              <DialogActions>
                <Button  onClick={handleCloseLogin}>Annulla</Button>
                <Button  variant="contained" onClick={login}>Login</Button>
              </DialogActions>
            </Dialog>

            <Toolbar sx={{ justifyContent: "space-between" }} disableGutters={true}>
          {/* <Typography  variant="h4" component="h2">
            Salento Padel
          </Typography> */}
          
          
          <Stack  spacing={1} 
            direction="column"
            justifyContent="center"
            alignItems="flext-start"
            className="top-center-stack"
          >
            
            {/* <Chip
            // variant="outlined"
              color="primary"
              label='+39 377 3861132'
              onClick={() =>{window.location.href = 'tel:+39 377 3861132'}}
              // onDelete={logout}
              icon={<LocalPhoneRoundedIcon />}
              size="small"
              className="phone-chip"
              // variant="outlined"
            /> */}
            <Chip
            // variant="outlined"
              color="secondary"
              label='Via Matine, 139 73031 Alessano'
              // onClick={() =>{window.location.href = 'tel:+39 377 3861132'}}
              // onDelete={logout}
              icon={<LocationOnIcon />}
              size="small"
              // variant="outlined"
            />
          </Stack>
          
          <Stack  spacing={2} 
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
            className="top-right-stack"
          >
          <Box>
          <IconButton color="primary" href="https://www.facebook.com/SalentoPadelSport" target="_blank">
            <FacebookIcon />
          </IconButton>
          <IconButton color="secondary" href="https://www.instagram.com/salentopadelclub/" target="_blank">
            <InstagramIcon />
          </IconButton>

          </Box>
          </Stack>
        </Toolbar>

      </Container>
      {/* <header className="App-header">
        <h1>
          Lista campi
        </h1>
        <ul>
        {todos.map(item=> <Todo key={item.id} arr={item} />)}
        </ul>
      </header> */}
    </div>
  );
}

export default App;
